/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */
import React from 'react';

import { jsx } from '@compiled/react';

import { Box } from '@atlaskit/primitives/compiled';

export const MessageLoadingPaddedContainer = ({
	children,
}: {
	children?: React.ReactNode;
}): JSX.Element => {
	return <Box paddingBlockStart="space.150">{children}</Box>;
};
